import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPostcssComponent } from './simple-icons-postcss.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPostcssComponent ],
    exports:      [ SimpleIconsPostcssComponent ],
    bootstrap:    []
})
export class SimpleIconsPostcssModule {}
